import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import { sortBy } from 'lodash'

import { Button, Select, mapToOptions } from 'src/modules/ui'

import { useSuppliers } from '../hooks'

const useStyles = makeStyles(theme => ({
  clearButton: {
    marginTop: theme.spacing(1),
  },
  filter: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  filterContainer: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filterLabel: {
    color: theme.palette.purple.main,
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
  },
}))

const SupplierFilters = ({ className }) => {
  const classes = useStyles()
  const {
    allergenFilterChoices,
    allergenFilters,
    category,
    categoryChoices,
    dietaryFilterChoices,
    dietaryFilters,
    setAllergenFilters,
    setCategory,
    setDietaryFilters,
    setSubcategory,
    setSustainabilityFilters,
    subcategory,
    sustainabilityFilterChoices,
    sustainabilityFilters,
  } = useSuppliers()

  const handleChange = changeFunction => event =>
    changeFunction(event.target.value)

  // Category
  const handleMainCategoryChange = event => {
    setCategory(event.target.value)
    setSubcategory('')
  }

  const handleSubcategoryChange = event => {
    setSubcategory(event.target.value)
  }

  const handleClearAll = () => {
    setCategory('')
    setSubcategory('')
  }

  const mainCategory = categoryChoices.find(item => item.id === category)
  const categoryOptions = categoryChoices.map(mapToOptions)
  const subcategories = (mainCategory && mainCategory.subcategories) || []
  const subcategoryOptions = subcategories.map(mapToOptions)

  // Sort filters
  const sortedSustainablity = sortBy(
    sustainabilityFilterChoices,
    'group',
    'name'
  )
  const sortedAllergens = sortBy(allergenFilterChoices, 'group', 'name')

  // Filters
  const filters = [
    {
      clearText: 'Clear Sustainability',
      groupOptionsBy: 'group',
      options: sortedSustainablity.map(({ id, name, group }) => ({
        label: name,
        value: id,
        group,
      })),
      onChange: handleChange(setSustainabilityFilters),
      placeholder: 'Sustainability',
      value: sustainabilityFilters,
    },
    {
      clearText: 'Clear Dietary',
      options: dietaryFilterChoices.map(mapToOptions),
      onChange: handleChange(setDietaryFilters),
      placeholder: 'Dietary',
      value: dietaryFilters,
    },
    {
      clearText: 'Clear Allergens',
      groupOptionsBy: 'group',
      options: sortedAllergens.map(({ id, name, group }) => ({
        label: `${name}-free`,
        value: id,
        group,
      })),
      onChange: handleChange(setAllergenFilters),
      placeholder: 'Allergens',
      value: allergenFilters,
    },
  ]

  return (
    <div className={className}>
      <div className={classes.filterContainer}>
        <Typography className={classes.filterLabel}>
          Product Category
        </Typography>
        <Select
          className={classes.filter}
          clearText="Any Category"
          fullWidth
          onChange={handleMainCategoryChange}
          options={categoryOptions}
          placeholder="Category"
          value={category}
        />
        {subcategories.length > 0 && (
          <>
            <Select
              className={classes.filter}
              clearText="Any Subcategory"
              fullWidth
              onChange={handleSubcategoryChange}
              options={subcategoryOptions}
              placeholder="Subcategory"
              value={subcategory}
            />
            <Button
              className={classes.clearButton}
              fullWidth
              onClick={handleClearAll}
            >
              Clear
            </Button>
          </>
        )}
      </div>
      <div className={classes.filterContainer}>
        <Typography className={classes.filterLabel}>Filter</Typography>
        {filters.map((filter, idx) => (
          <Select
            className={classes.filter}
            fullWidth
            key={idx}
            multiple
            {...filter}
          />
        ))}
      </div>
    </div>
  )
}

export default SupplierFilters
